import ResultsVisualization from './ResultsVisualization.component';

export default ResultsVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/index.js